







import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LoginTopNav extends Vue {
    @Prop() private title: string;
    
    private back() {
        this.$router.back();
    }
}

Vue.component("mt-login-top-nav", LoginTopNav);
